/**
 * Account Settings Page
 * User account management and settings
 */

import { useAuth } from '../contexts/AuthContext';

export function Account() {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return (
      <div className="text-center py-12">
        <h1 className="text-3xl font-bold text-neutral-900 mb-4">Account Settings</h1>
        <p className="text-neutral-600 mb-6">Please log in to view your account settings.</p>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-neutral-900 mb-2">Account Settings</h1>
        <p className="text-neutral-600">
          Manage your account information and preferences
        </p>
      </div>

      {/* Profile Information Section */}
      <div className="card mb-6">
        <h2 className="text-xl font-semibold text-neutral-900 mb-4">Profile Information</h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-neutral-700 mb-1">
              Email Address
            </label>
            <div className="px-3 py-2 bg-neutral-50 border border-neutral-200 rounded-md text-neutral-900">
              {user?.email}
            </div>
          </div>
        </div>
      </div>

      {/* Account Actions Section */}
      <div className="card">
        <h2 className="text-xl font-semibold text-neutral-900 mb-4">Account Actions</h2>
        <div className="space-y-4">
          <div className="pb-4 border-b border-neutral-200">
            <h3 className="text-sm font-medium text-neutral-900 mb-1">Change Email</h3>
            <p className="text-sm text-neutral-600 mb-3">
              Update your email address for login and notifications
            </p>
            <button
              disabled
              className="px-4 py-2 bg-neutral-100 text-neutral-400 rounded-md text-sm font-medium cursor-not-allowed"
            >
              Coming Soon
            </button>
          </div>

          <div>
            <h3 className="text-sm font-medium text-neutral-900 mb-1">Delete Account</h3>
            <p className="text-sm text-neutral-600 mb-3">
              Permanently delete your account and all associated data
            </p>
            <button
              disabled
              className="px-4 py-2 bg-neutral-100 text-neutral-400 rounded-md text-sm font-medium cursor-not-allowed"
            >
              Coming Soon
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
